import { SxProps } from '@mui/system';
import { MyTheme } from 'src/theme';

export const alertsContainerStyles: SxProps<MyTheme> = {
  zIndex: ({ zIndex }) => (zIndex as unknown as Record<string, number>).snackbar,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
};

export const alertStyles: SxProps<MyTheme> = {
  textAlign: 'center',
  justifyContent: 'center',
  '& .MuiAlert-action': {
    position: 'absolute',
    right: 16,
    marginLeft: 0,
  },
};
